import React from 'react';
import {
  FormPageInputItemPasswordHash,
  FormPageInputItemPasswordHashText,
  PasswordHashProperty,
  PasswordHashPropertyText,
  PASSWORD_HASH_PROPERTY_INPUT_TYPE,
} from 'shared';
import { FormFieldInputProps, hasErrorMessage } from '../shared';
import { PasswordHashReEnter } from './PasswordHashReEnter';
import { PasswordHashText } from './PasswordHashText';
import { PasswordDisplayProps } from './shared';

export type PasswordHashInputProps = FormFieldInputProps<
  PasswordHashProperty,
  FormPageInputItemPasswordHash
> &
  PasswordDisplayProps;

const isError = (
  errorMessages: PasswordHashInputProps['errorMessages'],
  displayError = false
): boolean => !!displayError && hasErrorMessage(errorMessages);

export const PasswordHashInput: React.FC<PasswordHashInputProps> = (props) => {
  if (props.reEnter) {
    const { submitted, touched, errorMessages, value, property, ...baseProps } =
      props;
    const displayError = submitted || (touched && touched.password);
    return (
      <PasswordHashReEnter
        property={property}
        value={value.password ?? ''}
        displayError={isError(errorMessages, displayError)}
        errorMessages={errorMessages}
        {...baseProps}
      />
    );
  }
  switch (props.property.inputFormat.inputType) {
    case PASSWORD_HASH_PROPERTY_INPUT_TYPE.text: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldInputProps<
          PasswordHashPropertyText,
          FormPageInputItemPasswordHashText
        > &
          PasswordDisplayProps;
      const displayError = submitted || (touched && touched.password);
      return (
        <PasswordHashText
          value={value.password ?? ''}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
  }
};
